import React from 'react';
import './PreLaunchNoticeModal.css';

interface PreLaunchNoticeModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const PreLaunchNoticeModal: React.FC<PreLaunchNoticeModalProps> = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="pln-backdrop" role="dialog" aria-modal="true" onClick={onClose}>
      <div className="pln-card" onClick={(e) => e.stopPropagation()}>
        <div className="pln-header">
          <span className="pln-tag">PLATFORM PREVIEW</span>
          <h2 className="pln-title">Early Access & Onboarding Notice</h2>
        </div>

        <div className="pln-body">
          <p className="pln-text">
            We have not launched yet. This is just for onboarding, you can explore the site while development is still ongoing. We will email you at launch.
          </p>
        </div>

        <div className="pln-footer">
          <button type="button" className="pln-btn" onClick={onClose}>
            Explore Platform
          </button>
        </div>
      </div>
    </div>
  );
};
